var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "fieldset",
    { ref: "fieldset", attrs: { id: _setup.fieldsetId, name: _vm.legend } },
    [
      !_vm.isFirst && _vm.showLegends
        ? _c("legend", { staticClass: "legend mt-5" }, [
            _vm._v("\n        " + _vm._s(_vm.legend) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_setup.fieldsetsFields, function (field) {
        return _c(_setup.FormGroup, {
          key: field.id,
          staticClass: "pb-3",
          class: { "mb-3": _setup.formSmall, "mb-4": !_setup.formSmall },
          attrs: {
            field: field,
            "form-id": _vm.formId,
            "hide-help-text": _vm.hideHelpText,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }